import { progressAnatomy as parts } from "@chakra-ui/anatomy"
import {
  generateStripe,
  getColor,
  mode,
  PartsStyleFunction,
  PartsStyleObject,
  StyleFunctionProps,
} from "@chakra-ui/theme-tools"
import type {
  SystemStyleObject,
  SystemStyleFunction,
} from "@chakra-ui/theme-tools"
import { $color } from "@/utils/cssVarUtils"


function filledStyle(props: StyleFunctionProps): SystemStyleObject {
  const { colorScheme: c, isIndeterminate, hasStripe } = props

  const stripeStyle = mode(
    generateStripe(),
    generateStripe("1rem", "rgba(0,0,0,0.1)"),
  )(props)

  const bgColor = $color(`scene-${c}-normal`)

  const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${bgColor} 50%,
    transparent 100%
  )`

  const addStripe = !isIndeterminate && hasStripe

  return {
    ...(addStripe && stripeStyle),
    ...(isIndeterminate ? { bgImage: gradient } : { bgColor }),
  }
}

const baseStyleLabel: SystemStyleObject = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: $color('text-normal'),
}

const baseStyleTrack: SystemStyleFunction = (props) => {
  return {
    bg: $color('bg-input-normal'),
    borderRadius: '4xs',
  }
}

const baseStyleFilledTrack: SystemStyleFunction = (props) => {
  return {
    transitionProperty: "common",
    transitionDuration: "slow",
    ...filledStyle(props),
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  label: baseStyleLabel,
  filledTrack: baseStyleFilledTrack(props),
  track: baseStyleTrack(props),
})

const sizes: Record<string, PartsStyleObject<typeof parts>> = {
  xs: {
    track: {
      h: '3xs',
    },
  },
  sm: {
    track: {
      h: '2xs',
    },
  },
  md: {
    track: {
      h: 'xs',
    },
  },
  lg: {
    track: {
      h: "md",
    },
  },
}

const defaultProps = {
  size: "sm",
  colorScheme: "primary",
}

export const Progress = {
  parts: parts.keys,
  sizes,
  baseStyle,
  defaultProps,
}